var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"home-social"},[_vm._l((_vm.socialButtons),function(button){return [_c('li',[_c('a',{attrs:{"href":button[1]}},[_c('i',{class:button[2],attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(_vm._s(_vm.$t('titles.' + button[0])))])])])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1855116a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/socialButtons/ButtonsTitles.vue
// module id = null
// module chunks = 